<template>
    <v-menu>
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" v-if="mode !== 'ebook'">
                <img src="../../assets/icons/generals/share.png" class="tcdc-share-icon" />
            </v-btn>
            <v-layout v-on="on" v-else v-ripple style="border-radius: 30px; width: 250px;">
                <v-flex shrink px-3 py-2 d-flex>
                    <img src="../../assets/icons/generals/share.png" class="tcdc-share-icon mr-4" />
                    <span class="text-tcdc-green bold" style="white-space: nowrap">Share this E-Book</span>
                </v-flex>
            </v-layout>
        </template>
        <v-list dense>
            <v-list-item
                    v-for="(item, i) in shareMenus"
                    :key="i"
                    v-ripple
                    @click="shareTo(item.name)"
            >
                <img
                        width="30px"
                        class="mr-2"
                        style="border-radius: 100%"
                        :src="item.icon"
                >
                {{item.name}}
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import { domain_web } from "../../util/Constants";
    import { mapState } from "vuex";

    export default {
        name: "ShareButton",
        props: {
          mode: {
              type: String,
              default: ""
          }
        },
        data: () => ({
            shareMenus: [
                {
                    icon: require('../../assets/icons/social/facebook.png'),
                    name: 'Facebook',
                },
                {
                    icon: require('../../assets/icons/social/twitter.png'),
                    name: 'Twitter',
                }
            ],
            http: domain_web
        }),
        computed: {
          ...mapState({
              lang: state => state.Branch.lang
          })
        },
        methods: {
            shareTo(social) {
                let fb = 'https://www.facebook.com/sharer/sharer.php?u=';
                switch (social) {
                    case "Facebook":
                        // facebook shares
                        switch (this.mode) {
                            case 'online-exhibition':
                                window.open(`${fb + this.http}/share/online-ex/${this.$route.params.id}?lang=${this.lang}`);
                                break;
                            case 'program':
                                window.open(`${fb + this.http}/share/product/${this.$route.params.id}?lang=${this.lang}`);
                                break;
                            case 'news':
                                window.open(`${fb + this.http}/share/news/${this.$route.params.id}?lang=${this.lang}`);
                                break;
                            case 'world-calendar':
                                window.open(`${fb + this.http}/share/world-calendar/${this.$route.params.id}?lang=${this.lang}`);
                                break;
                            case 'article':
                            case 'ebook':
                                window.open(`${fb + this.http}/share/article/${this.$route.params.id}?lang=${this.lang}`);
                                break;
                        }
                        break;

                    case "Twitter":
                        // twitter shares
                        window.open(`https://twitter.com/intent/tweet?url=${window.location}`);
                        break;
                }
            }
        }
    }
</script>

<style scoped>

</style>
